<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <i
          class="bx bxs-left-arrow"
          style="float: left; font-size: 1.5rem"
          onclick="history.back()"
        ></i>

        <h5 class="text-center">
          Report {{ this.selectedIncidentDetailsObj.category_name }}
        </h5>
        <hr />
        <form @submit.prevent="reportIncident" class="p-1 mb-3">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label>Id</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.id"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label>Event</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.category_name"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label>Incident Source</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.source_name"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label>Chainage No.</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.ch_no"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Side</label>
                <v-select
                  class="style-chooser"
                  v-model="selectedIncidentDetailsObj.side_name"
                  :options="options.side"
                  label="side_name"
                  :reduce="(side) => side.id"
                  required
                ></v-select>
              </div>
              <div
                class="mb-3"
                v-if="selectedIncidentDetailsObj.category_name === 'Incident'"
              >
                <label>Vehicle Number</label>
                <input
                  class="form-control inp-bg"
                  placeholder="Enter Vehicle Number"
                  v-model="selectedIncidentDetailsObj.vehicle_no"
                  required
                />
              </div>
              <div
                class="mb-3"
                v-if="selectedIncidentDetailsObj.category_name === 'Incident'"
              >
                <label>Vehicle Class</label>
                <v-select
                  class="form-control"
                  v-model="selectedIncidentDetailsObj.vehicleClass"
                  :options="options.vehicleClass"
                  label="class_name"
                  :reduce="(category) => category.id"
                ></v-select>
              </div>
            </div>
          </div>
          <div
            v-if="selectedIncidentDetailsObj.category_name === 'Accident'"
            class="row"
          >
            <div class="col-12">
              <div class="mb-3">
                <label>Nature of Accident</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.nature_of_accident"
                  placeholder="Enter nature of accident"
                />
              </div>
              <div class="mb-3">
                <label>Reason of Accident</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.reason_of_accident"
                  placeholder="Enter reason of accident"
                />
              </div>
              <div class="mb-3">
                <label>Nature of Injury</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.nature_of_injury"
                  placeholder="Enter nature of injury"
                />
              </div>
              <div class="mb-3">
                <label>Name of Police Station</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.police_station"
                  placeholder="Enter name of police station"
                />
              </div>
              <div class="mb-3">
                <label>Name of Hospital</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.hospital_name"
                  placeholder="Enter name of hospital"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div
                v-if="selectedIncidentDetailsObj.category_name === 'Accident'"
                class="mb-3"
              >
                <label>MBCB</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.mbcb"
                />
              </div>
              <div
                v-if="selectedIncidentDetailsObj.category_name === 'Accident'"
                class="mb-3"
              >
                <label>Hydra Time</label>
                <input
                  class="form-control inp-bg"
                  type="time"
                  v-model="selectedIncidentDetailsObj.hydra_time"
                />
              </div>
              <div class="mb-3">
                <label>Description</label>
                <textarea
                  class="form-control inp-bg"
                  v-model="selectedIncidentDetailsObj.description"
                  rows="3"
                  placeholder="More details about the incident"
                ></textarea>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-if="selectedIncidentDetailsObj.category_name === 'Accident'"
          >
            <h5 class="col-8">Add Vehicle Details</h5>
            <a @click="addVehicleDetails" class="btn btn-primary btn-sm col-4"
              >Add</a
            >
          </div>
          <hr />
          <div
            class="row"
            v-if="selectedIncidentDetailsObj.category_name === 'Accident'"
          >
            <div class="col-12">
              <div class="mb-3">
                <b-table-lite :items="items" :fields="fields">
                  <template #cell(actions)="row">
                    <b-button
                      size="sm"
                      variant="primary"
                      class="m-1"
                      @click="editVehicleDetails(row.item)"
                      ><i class="bx bx-pencil"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      variant="danger"
                      class="m-1"
                      @click="deleteVehicleDetails(row.item.id)"
                      ><i class="bx bx-trash"></i>
                    </b-button>
                  </template>
                </b-table-lite>
              </div>
            </div>
          </div>

          <!-- Image Upload -->
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label>Incident Images</label>
                <file-pond
                  ref="pond"
                  class="inp-bg"
                  label-idle="Attach Incident Images"
                  :allow-multiple="true"
                  accepted-file-types="image/jpeg, image/png"
                  max-files="6"
                  :files="myFiles"
                  :credits="credits"
                  imagePreviewMaxHeight="70"
                />
              </div>
            </div>
          </div>
          <!-- BUTTON -->
          <div class="row">
            <hr />
            <div class="col-12">
              <button type="submit" class="btn btn-primary me-1 w-100">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
      <!-- add vehicle details modal -->
      <b-modal
        id="add-vehicle-details-modal"
        title="Add Vehicle Details"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
      >
        <template #modal-header>
          <div><h5>Add Accident Vehicle</h5></div>
          <div>
            <button
              class="btn btn-sm btn-outline-danger"
              @click="$bvModal.hide('add-vehicle-details-modal')"
            >
              Cancel
            </button>
          </div>
        </template>
        <div class="card">
          <div class="card-body p-2">
            <form @submit.prevent="submitVehicleDetails">
              <div class="mb-3">
                <label>Driver Name</label>
                <input
                  class="form-control inp-bg"
                  v-model="addVehicleDetailsObj.driverName"
                  placeholder="Enter driver name"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Vehicle No.</label>
                <input
                  class="form-control inp-bg"
                  v-model="addVehicleDetailsObj.vehicleNumber"
                  placeholder="Enter vehicle number"
                  style="text-transform: uppercase"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Vehicle Class</label>
                <v-select
                  class="form-control"
                  v-model="addVehicleDetailsObj.vehicleClass"
                  :options="options.vehicleClass"
                  label="class_name"
                  :reduce="(category) => category.id"
                ></v-select>
              </div>
              <div class="mb-3">
                <label>Mobile No.</label>
                <input
                  class="form-control inp-bg"
                  v-model="addVehicleDetailsObj.mobileNumber"
                  placeholder="Enter mobile number"
                />
              </div>
              <div class="mb-3">
                <label>Driver Address</label>
                <input
                  class="form-control inp-bg"
                  v-model="addVehicleDetailsObj.driverAddress"
                  placeholder="Enter driver address"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Origin of Vehicle</label>
                <input
                  class="form-control inp-bg"
                  v-model="addVehicleDetailsObj.originAddress"
                  placeholder="Enter origin of Vehicle"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Point of Arrival</label>
                <input
                  class="form-control inp-bg"
                  v-model="addVehicleDetailsObj.arrivalPoint"
                  placeholder="Enter point of arrival"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Destination of Vehicle</label>
                <input
                  class="form-control inp-bg"
                  v-model="addVehicleDetailsObj.destination"
                  placeholder="Enter destination of vehicle"
                  required
                />
              </div>

              <div class="mb-3">
                <label>No. of Passengers</label>
                <input
                  class="form-control inp-bg"
                  type="number"
                  v-model="addVehicleDetailsObj.passengers"
                  placeholder="Enter destination of vehicle"
                  required
                />
              </div>

              <hr />
              <div class="row">
                <div class="col-12 text-center">
                  <button type="submit" class="btn btn-success btn-block">
                    <i class="fas fa-check"></i> Add Vehicle Details
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </b-modal>

      <!-- Edit vehicle details -->
      <b-modal
        id="edit-vehicle-details-modal"
        title="Edit Vehicle Details"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
      >
        <template #modal-header>
          <div><h5>Edit Accident Vehicle</h5></div>
          <div>
            <button
              class="btn btn-sm btn-outline-danger"
              @click="$bvModal.hide('edit-vehicle-details-modal')"
            >
              Cancel
            </button>
          </div>
        </template>
        <div class="card">
          <div class="card-body p-2">
            <form @submit.prevent="submitEditVehicleDetails">
              <div class="mb-3">
                <label>Driver Name</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedVehicle.driver_name"
                  placeholder="Enter driver name"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Vehicle No.</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedVehicle.vehicle_no"
                  placeholder="Enter vehicle number"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Vehicle Class</label>
                <v-select
                  class="form-control"
                  v-model="vehicleClass"
                  :options="options.vehicleClass"
                  label="class_name"
                  :reduce="(category) => category.class_name"
                ></v-select>
              </div>
              <div class="mb-3">
                <label>Mobile No.</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedVehicle.mobile_no"
                  placeholder="Enter mobile number"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Driver Address</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedVehicle.driver_address"
                  placeholder="Enter driver address"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Origin of Vehicle</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedVehicle.origin"
                  placeholder="Enter origin of Vehicle"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Point of Arrival</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedVehicle.arrival"
                  placeholder="Enter point of arrival"
                  required
                />
              </div>
              <div class="mb-3">
                <label>Destination of Vehicle</label>
                <input
                  class="form-control inp-bg"
                  v-model="selectedVehicle.destination"
                  placeholder="Enter destination of vehicle"
                  required
                />
              </div>

              <div class="mb-3">
                <label>No. of Passengers</label>
                <input
                  class="form-control inp-bg"
                  type="number"
                  v-model="selectedVehicle.passenger_count"
                  placeholder="Enter destination of vehicle"
                  required
                />
              </div>

              <hr />
              <div class="row">
                <div class="col-12 text-center">
                  <button type="submit" class="btn btn-success btn-block">
                    <i class="fas fa-check"></i> Edit Vehicle Details
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>

<script>
import incidentMixin from "@/mixins/incident";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import Layout from "@/layouts/main";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

import appConfig from "@/app.config";
import Swal from "sweetalert2";

export default {
  mixins: [incidentMixin],

  page: {
    title: "Report Incident",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    FilePond,
    Layout,
  },
  data() {
    return {
      vehicleClass: null,
      incidentCategoryId: null,
      subCategoryId: null,
      incidentSourceId: null,
      incidentDescription: null,
      chainageNo: null,
      sideId: null,
      injuredCount: null,
      incidentDate: null,
      incidentTime: null,
      informedTo: null,
      credits: "",
      userRole: null,
      challanStatusId: null,
      selectedIncident: {},
      incident_id: null,
      driver_name: null,
      vehicle_no: null,
      mobile_no: null,
      driver_address: null,
      origin_of_vehicle: null,
      point_of_arrival: null,
      destination_of_vehicle: null,
      no_of_passengers: null,

      addVehicleDetailsObj: {},
      selectedIncidentDetailsObj: {},
      selectedVehicle: {},

      options: {
        incidentCategory: [],
        subCategory: [],
        incidentSource: [],
        side: [],
        informedTo: [],
        vehicleClass: [],
      },

      items: [],

      fields: [
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "driver_name",
          label: "Driver Name",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],

      image: "",
      file: "",
      myFiles: [],
    };
  },

  watch: {
    incidentCategoryId: function () {
      if (this.incidentCategoryId == 1) this.subCategoryId = null;
    },
  },

  methods: {
    addVehicleDetails() {
      this.$bvModal.show("add-vehicle-details-modal");
    },

    async submitVehicleDetails() {
      try {
        this.addVehicleDetailsObj.incident_id = this.selectedIncident.id;
        this.AddVehicleDetails(this.addVehicleDetailsObj);
        Swal.fire(
          "Saved!",
          "Vehicle details saved successfully",
          "success"
        ).then(async () => {
          this.$bvModal.hide("add-vehicle-details-modal");
          this.addVehicleDetailsObj = {};
          await this.showVehicles(this.selectedIncident.id);
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to create VSDS", "error");
      }
    },

    editVehicleDetails(vehicle) {
      this.selectedVehicle = vehicle;
      const vehicleClass = this.options.vehicleClass.find(
        (vehicleClass) =>
          vehicleClass.id === this.selectedVehicle.vehicle_class_id
      );
      this.vehicleClass = vehicleClass.class_name;
      this.$bvModal.show("edit-vehicle-details-modal");
    },

    async submitEditVehicleDetails() {
      try {
        const vehicleClassId = this.options.vehicleClass.find(
          (vehicleClass) => vehicleClass.class_name === this.vehicleClass
        );
        this.selectedVehicle.incident_id = this.selectedIncident.id;
        this.selectedVehicle.vehicleClass = vehicleClassId.id;
        this.EditVehicleDetails(this.selectedVehicle);
        Swal.fire(
          "Updated!",
          "Vehicle details updated successfully",
          "success"
        ).then(async () => {
          this.$bvModal.hide("edit-vehicle-details-modal");
          this.addVehicleDetailsObj = {};
          await this.showVehicles(this.selectedIncident.id);
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to update vehicle details", "error");
      }
    },

    deleteVehicleDetails(id) {
      try {
        const body = {
          id: id,
        };
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            await this.DeleteVehicleDetails(body);
            await this.showVehicles(this.selectedIncident.id);
          }
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to delete VSDS", "error");
      }
    },

    async reportIncident() {
      try {
        this.ReportIncident(this.selectedIncidentDetailsObj);
        await this.saveIncidentImages(this.selectedIncidentDetailsObj.id);
        Swal.fire("Saved!", "Report saved successfully", "success").then(() => {
          this.$router.push("/phone/incidents");
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to create VSDS", "error");
      }
    },

    async getIncidentMasters() {
      try {
        const incidents = await this.GetIncidentMasters();
        this.options.incidentCategory = incidents.getIncidentCategory;
        this.options.subCategory = incidents.getIncidentSubCategory;
        this.options.incidentSource = incidents.getIncidentSource;
        this.options.side = incidents.getIncidentSide;
        this.options.informedTo = incidents.rpoData;
        this.options.vehicleClass = incidents.getVehicleClass;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async saveIncidentImages(incidentId) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        if (this.$refs.pond) {
          const files = this.$refs.pond.getFiles();
          for (let file of files) {
            let formData = new FormData();
            formData.append("photo", file.file);
            formData.append("id", incidentId);
            await this.SaveIncidentImages(formData);
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Error Occurred", e.response.data.message, "error");
        this.clearData();
      }
    },

    getUsers() {
      this.userRole = this.$store.getters["auth/user"].user.role;
    },

    clearData() {
      this.incidentCategoryId = null;
      this.subCategoryId = null;
      this.incidentSourceId = null;
      this.incidentDescription = null;
      this.chainageNo = null;
      this.sideId = null;
      this.vehicleNumber = null;
      this.incidentDate = null;
      this.incidentTime = null;
      this.informedTo = null;

      if (this.$refs.pond) {
        this.$refs.pond.removeFiles();
      }

      this.$emit("closeModal");
    },

    async showVehicles(id) {
      const body = {
        id: id,
      };
      this.items = await this.ShowVehicleDetails(body);
    },

    formatDate(d) {
      const date = new Date(d);
      let day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
  },
  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    await this.getIncidentMasters();
    this.$store.dispatch("layout/changeLoaderValue", false);
    this.getUsers();
    this.informedTo = this.$store.getters["auth/user"].user.first_name;
  },

  created() {
    this.selectedIncident = this.$route.params.data;
    this.showVehicles(this.selectedIncident.id);
    this.selectedIncidentDetailsObj.id = this.selectedIncident.id;
    this.selectedIncidentDetailsObj.category_name =
      this.selectedIncident.category_name;
    this.selectedIncidentDetailsObj.source_name =
      this.selectedIncident.source_name;
    this.selectedIncidentDetailsObj.ch_no = this.selectedIncident.ch_no;
    this.selectedIncidentDetailsObj.side_name = this.selectedIncident.side_name;
    this.selectedIncidentDetailsObj.nature_of_accident =
      this.selectedIncident.nature_of_accident;
    this.selectedIncidentDetailsObj.reason_of_accident =
      this.selectedIncident.reason_of_accident;
    this.selectedIncidentDetailsObj.nature_of_injury =
      this.selectedIncident.nature_of_injury;
    this.selectedIncidentDetailsObj.police_station =
      this.selectedIncident.police_station;
    this.selectedIncidentDetailsObj.hospital_name =
      this.selectedIncident.hospital_name;
    this.selectedIncidentDetailsObj.mbcb = this.selectedIncident.mbcb;
    this.selectedIncidentDetailsObj.hydra_time =
      this.selectedIncident.hydra_time;
    this.selectedIncidentDetailsObj.description =
      this.selectedIncident.description;
    this.selectedIncidentDetailsObj.vehicle_no =
      this.selectedIncident.vehicle_no;
  },
};
</script>
<style>
.filepond--root {
  font-family: "Poppins", sans-serif;
}

.filepond--panel-root {
  background-color: #2a3042;
}

.filepond--drop-label {
  color: #a6b0cf;
  font-size: 10px;
}

textarea::placeholder,
input::placeholder {
  color: #717174 !important;
}

.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__selected,
.vs__dropdown-menu {
  background: #2a3042;
  border: none;
  color: #a6b0cf;
  font-size: 13px;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected .vs--disabled::placeholder {
  background-color: #1a2031;
  color: #1a2031;
}

.vs__disabled-bg {
  background: #333f78;
}

.vs__clear,
.vs__open-indicator {
  fill: #394066;
}

@media (min-width: 30em) {
  .filepond--item {
    width: calc(50% - 0.5em);
  }
}

@media (min-width: 50em) {
  .filepond--item {
    width: calc(16.66% - 0.5em);
  }
}

.footer-raise-btn {
  position: fixed;
  bottom: 80px;
  width: 97%;
}
</style>
